(function () {
  'use strict';

  /**
   * @typedef {import('./types').PopupScope} PopupScope
   */

  angular
    .module('settings.popup')
    .controller('settingsPopupCtrl', settingsPopupCtrl);

  settingsPopupCtrl.$inject = ['$mdDialog', '$scope'];

  /**
   * @param {angular.material.IDialogService} $mdDialog
   * @param {PopupScope} $scope
   */
  function settingsPopupCtrl($mdDialog, $scope) {
    var vm = this;
    vm.loaded = true;
    vm.model = $scope.model;
    vm.data = $scope.data;

    vm.onSubmit = function () {
      $scope.object = vm.model;
      $scope.onSubmit({ object: $scope.object });
      vm.closeDialog();
    };

    vm.closeDialog = function () {
      $mdDialog.hide();
      $scope.onBack();
    };
  }
})();
